// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xl_d","fullView":"styles_fullView__2zZn4"};